// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FYnC","colBig":"styles_colBig__2-Nxt","colSmall":"styles_colSmall__SDS9y"};